export default "__VITE_ASSET__DUA2tiisjIeXzZF24PX2uA__"